import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shop/price-box.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shop/promotion-slide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shop/shop-cart.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/shop/shop-detail-home.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shop/shop-detail-info-date.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shop/shop-detail-share.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shop/shop-detail-tab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogContent","DialogTitle"] */ "/app/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/lib/context/client-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/lib/context/store-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
